/* import __COLOCATED_TEMPLATE__ from './spam-settings.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency-decorators';

export default class SpamSettings extends Component {
  @service store;
  @service notificationsService;
  @service intl;

  @task({ enqueue: true })
  *updateSetting() {
    try {
      yield this.args.settings.save();
      this.notificationsService.notifyConfirmation(
        this.intl.t('channels.email.settings.update_success'),
      );
    } catch (error) {
      this.args.settings.toggleProperty('allowAutoResponders');
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t('channels.email.settings.update_failure'),
      });
    }
  }

  @action
  toggleAutoResponders() {
    this.args.settings.toggleProperty('allowAutoResponders');
    this.updateSetting.perform();
  }
}
